/** SSR/workers-safe header chrome sticky flags and class names (no DOM APIs). */

export function resolveHeaderChromeSticky(value: unknown): boolean {
  return value === true || value === 'true';
}

/** Full-width shell for logo/search/actions (like `.storefront-nav-bar` for menu links). */
export function headerChromeShellClassName(): string {
  return 'storefront-header-chrome';
}

export function headerChromeInnerClassName(): string {
  return 'container storefront-header-chrome__inner';
}
